module.exports = __webpack_public_path__ + "img/gongying.7938b03c.png";